import { Link, Center, Box, Heading, Text, VStack, UnorderedList, ListItem } from '@chakra-ui/react';

export const Visitors = () => {
  return (
    <Box>
      <VStack spacing={6} align="stretch">
        <Box>
          <Text mb={4} color="black">
            The Shotgun facilities are open to the public.
          </Text>
          <Text mb={4} color="black">
            Golden Gun Club Rifle and Pistol Range is a private Members only range, however, Visitors are permitted on-site when hosted by a paid Member of the club.
          </Text>
          <Text mb={4} color="black">
            Please note the following policies apply to all Members and their Visitors:
          </Text>
          <UnorderedList spacing={2} ml={6} mb={4}>
            <ListItem>A Member is allowed a maximum of two (2) Visitors at a time per visit to the Club's facilities.</ListItem>
            <ListItem>Visitors are required to sign the Visitor waiver and submit a copy to the club prior to entering the facilities.</ListItem>
            <ListItem>A Visitor fee of $5 per Visitor per visit should be paid in the Clubhouse, or if the Clubhouse is closed, in the Visitor Payment box at the gate, prior to entering the facilities.</ListItem>
            <ListItem>Members are responsible for the behaviors of their Visitors, and violations of Club rules committed by Visitors may lead to consequences, up to and including membership revocation (at the discretion of the Club's Board of Directors), for the Member hosting those Visitors.</ListItem>
          </UnorderedList>
        </Box>

        <Center mt={6}>
          <Link 
            href="https://waiver.smartwaiver.com/w/od92eenscnkn8scdxzmayu/web/" 
            isExternal 
            bg="#FD5521" 
            color="#FFF" 
            p="22px 32px" 
            fontWeight="600" 
            borderRadius="6px"
            _hover={{ bg: "#E04A1C" }}
          >
            Complete Visitor Waiver
          </Link>
        </Center>
      </VStack>
    </Box>
  )
}